import type { GovernmentDependency } from "~/types/company";

interface FinancialForDependency {
	year: number;
	revenue: number | null;
}

interface ContractSummaryForDependency {
	totalValueCzk: number | null;
	supplierCount: number;
}

export function deriveGovernmentDependency(
	financials: FinancialForDependency[],
	contracts: ContractSummaryForDependency | null,
): GovernmentDependency | null {
	if (!contracts || contracts.supplierCount === 0) return null;

	const latestFinancial = financials[0] ?? null;
	const revenue = latestFinancial?.revenue ?? null;
	const ratio =
		revenue != null && revenue > 0 && contracts.totalValueCzk != null
			? contracts.totalValueCzk / revenue
			: null;
	const riskLevel = ratio == null ? null : ratio > 0.6 ? "high" : ratio > 0.3 ? "moderate" : "low";

	return {
		ratio,
		totalContractValueCzk: contracts.totalValueCzk,
		latestRevenue: revenue,
		revenueYear: latestFinancial?.year ?? null,
		riskLevel,
		contractCount: contracts.supplierCount,
	};
}
